import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";

import { Switch } from "@treelab/panda";

import FormItem from "../FormItem";

import { IFormItemChangeValue } from "../../../../types/form-type";

import { Container, Label } from "./styled";

interface IProps {
  id: string;
  labelId: string;
  value?: boolean;
  onChange: (value: IFormItemChangeValue) => void;
}

const SwitchComponent: React.FC<IProps> = ({
  labelId,
  value = false,
  id,
  onChange,
}) => {
  const handleChange = useCallback(
    (isOpen: boolean, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      onChange({ [id]: isOpen });
    },
    [onChange, id]
  );
  return (
    <FormItem>
      <Container>
        <Label>
          <FormattedMessage id={labelId} />
        </Label>
        <Switch value={value} onClick={handleChange} />
      </Container>
    </FormItem>
  );
};

export default SwitchComponent;
